export default __webpack_public_path__ + "static/media/kashmir3.cfddb97e.jpg";